export default "__VITE_ASSET__BklOJTbi__"